// Regional Forecast map labels. ws4kp cut every city name at 12 letters, so "San Francisco" read "San Francisc" and
// "Mammoth Yosemite" "Mammoth Yose". Its formatCity now asks window.RHL.cityName first (upstream patch 6): a name in
// lineup.cityNames shows as given, a name of 13 letters or fewer as is, and a longer one is cut at a word.
const MAX = 13;
const names = Object.fromEntries(Object.entries(window.RHL?.lineup?.cityNames ?? {}).map(([k, v]) => [k.toLowerCase(), v]));

const cityName = (raw) => {
	const name = String(raw ?? '').replace(/\s+/g, ' ').trim();
	const given = names[name.toLowerCase()];
	if (given) return given;
	if (name.length <= MAX) return name;
	let out = '';
	name.split(' ').every((word) => {
		const next = out ? `${out} ${word}` : word;
		if (next.length > MAX) return false;
		out = next;
		return true;
	});
	return out.length >= 4 ? out : name.slice(0, MAX);
};

if (window.RHL) window.RHL.cityName = cityName;

export default cityName;
